export default {
    breadcrumb: {
        projectProfile: 'Project profile',
        admin: 'Admins',
    },
};
